import type React from "react";
import { createPortal } from "react-dom";

export const PortalToBody: React.FC<React.PropsWithChildren> = ({ children }) => createPortal(children, document.body);
